import MdmDashboard from '../components/modules/mdm-v2/MdmLanding';
import ActivityTime from '../components/modules/mdm-v2/activity-time';
import FreightZone from '../components/modules/mdm-v2/freight-zone';
import LegalEntity from '../components/modules/mdm-v2/legal-entity';
import MdmUpload from '../components/modules/mdm-v2/mdmUpload';
import TransshipmentMaster from '../components/modules/mdm-v2/transshipment';

const lazyLoad = view => () => import(`@/components/modules/mdm-v2/${view}`);

const mdmV2 = [
  {
    path: '/mdmLanding',
    name: 'MDM',
    component: MdmDashboard,
    meta: {
      title: 'MDM',
      requiresAuth: true,
    },
  },
  {
    path: '/mdmUpload',
    name: 'Upload',
    component: MdmUpload,
    meta: {
      title: 'MDM',
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: '/mdm/bucc',
    name: 'Bucc',
    component: lazyLoad('bucc'),
    meta: {
      title: 'BU CC',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/purchase-order',
    name: 'purchase_order',
    component: lazyLoad('purchase-order'),
    meta: {
      title: 'Purchase Order',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/port',
    name: 'Port',
    component: lazyLoad('ports'),
    meta: {
      title: 'Ports',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/cha',
    name: 'CHA',
    component: lazyLoad('cha'),
    meta: {
      title: 'CHA',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/container',
    name: 'Container',
    component: lazyLoad('container'),
    meta: {
      title: 'Container',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/freightForwarder',
    name: 'FreightForwarder',
    component: lazyLoad('freight-forwarder'),
    meta: {
      title: 'FreightForwarder',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/vehicledetail',
    name: 'VehicleDetail',
    component: lazyLoad('vehicle-detail'),
    meta: {
      title: 'Vehicle Details',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/vehicledetail/:id/details',
    name: 'VehicleDetailEdit',
    component: lazyLoad('vehicle-detail/edit'),
    meta: {
      title: 'Vehicle Details',
      requiresAuth: true,
      sectionName: 'vehicledetail',
    },
  },
  {
    path: '/mdm/vehicles',
    name: 'Vehicle',
    component: lazyLoad('vehicles'),
    meta: {
      title: 'Vehicles',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/cartonMaster',
    name: 'Carton',
    component: lazyLoad('carton'),
    meta: {
      title: 'Carton Master',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/carrier',
    name: 'Carrier',
    component: lazyLoad('carrier'),
    meta: {
      title: 'Carrier Master',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/shipMethod',
    name: 'ShipMethod',
    component: lazyLoad('ship-method'),
    meta: {
      title: 'ShipMethod Master',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/transportationDb',
    name: 'TransportationDB',
    component: lazyLoad('transportation-master'),
    meta: {
      title: 'Transportation DB',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/transporter',
    name: 'Transporter',
    component: lazyLoad('transporter'),
    meta: {
      title: 'Transporter',
      tlabel: 'MDM_TRANSPORTER',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/detentions',
    name: 'Detention',
    component: lazyLoad('detention'),
    meta: {
      title: 'Detention',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/user',
    name: 'User',
    component: lazyLoad('users'),
    meta: {
      title: 'User',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/billDiscount',
    name: 'BillDiscount',
    component: lazyLoad('bill-discount'),
    meta: {
      title: 'BillDiscount',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/consignees',
    name: 'Consignee',
    component: lazyLoad('consignee'),
    meta: {
      title: 'Consignees',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/consignees/:id',
    name: 'consigneeDetails',
    component: lazyLoad('consignee/show'),
    meta: {
      title: 'Consignees',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/consignees/new',
    name: 'consigneeDetails',
    component: lazyLoad('consignee/show'),
    meta: {
      title: 'Consignees',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/route',
    name: 'route_master',
    component: lazyLoad('route-master'),
    meta: {
      title: 'Routes',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/route/:id',
    name: 'routeDetails',
    component: lazyLoad('route-master/show'),
    meta: {
      title: 'Routes',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/route/new',
    name: 'routeDetails',
    component: lazyLoad('route-master/show'),
    meta: {
      title: 'Routes',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/destination-charges',
    name: 'destination_charge',
    component: lazyLoad('oda'),
    meta: {
      title: 'Destination Charges',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/destination-charges/:id',
    name: 'destination_charge_details',
    component: lazyLoad('oda/show'),
    meta: {
      title: 'Destination Charges - Details',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/source-charges',
    name: 'source_charge',
    component: lazyLoad('source-charge'),
    meta: {
      title: 'Source Charges',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/source-charges/:id',
    name: 'source_charge_details',
    component: lazyLoad('source-charge/show'),
    meta: {
      title: 'Source Charges - Details',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/transit-management',
    name: 'transit_management',
    component: lazyLoad('transit-management'),
    meta: {
      title: 'Transit Management',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/rate-matrix',
    name: 'contract',
    component: lazyLoad('rate-matrix'),
    meta: {
      title: 'Rate Matrix',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/rate-matrix/:id',
    name: 'contractDetails',
    component: lazyLoad('rate-matrix/show'),
    meta: {
      title: 'Rate Matrix',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/driver',
    name: 'Driver',
    component: lazyLoad('driver'),
    meta: {
      title: 'Driver',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/driver/:id',
    name: 'blacklist_driver_history',
    component: lazyLoad('driver/details'),
    meta: {
      title: 'Driver Blacklist History',
      requiresAuth: true,
    },
  }, {
    path: '/mdm/base-fuel-rate',
    name: 'bfr',
    component: () => import('@/components/modules/mdm-v2/base-diesel-rate'),
    meta: {
      title: 'Base Fuel Rate',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/bdr-history/:bdr_id/:category',
    name: 'bfr_history',
    component: () => import('@/components/modules/mdm-v2/base-diesel-rate/bdr-history'),
    meta: {
      title: 'BFR History',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/package',
    name: 'package_master',
    component: lazyLoad('package-master'),
    meta: {
      title: 'Package Master',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/depots',
    name: 'Depot',
    component: lazyLoad('depot'),
    meta: {
      title: 'Depots',
      tlabel: 'INDENT_DEPOT',
      requiresAuth: true,
      permission: 'view_depot',
    },
  },
  {
    path: '/mdm/depots/:id',
    name: 'DepotDetails',
    component: lazyLoad('depot/details'),
    meta: {
      title: 'Depots',
      requiresAuth: true,
      permission: 'view_depot',
    },
  },
  {
    path: '/mdm/depots/new',
    name: 'DepotDetails',
    component: lazyLoad('depot/details'),
    meta: {
      title: 'Depots',
      requiresAuth: true,
      permission: 'view_depot',
    },
  },
  {
    path: '/mdm/sla',
    name: 'sla',
    component: lazyLoad('sla'),
    meta: {
      title: 'SLA',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/material-package-mapping',
    name: 'material_package_map',
    component: lazyLoad('material-package-mapping'),
    meta: {
      title: 'Material Package Mapping',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/material-package-mapping/:id',
    name: 'material_package_details',
    component: lazyLoad('material-package-mapping/material-mapping'),
    meta: {
      title: 'Material Package Details',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/approval',
    name: 'Approval',
    component: lazyLoad('approval'),
    meta: {
      title: 'Approval',
    },
  },
  {
    path: '/mdm/contract-tsd-matrix',
    name: 'contracttsd',
    component: lazyLoad('contract-tsd-map'),
    meta: {
      title: 'Contract TSD Matrix',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/contract-tsd-matrix/:id',
    name: 'contractTSDMatrixDetails',
    component: lazyLoad('contract-tsd-map/show'),
    meta: {
      title: 'Contract TSD Matrix Details',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/activity-time',
    name: 'activity_time',
    component: ActivityTime,
    meta: {
      title: 'Activity Time SLA',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/materials',
    name: 'Material',
    component: lazyLoad('material'),
    meta: {
      title: 'Materials',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/materials/:id',
    name: 'MaterialDetails',
    component: lazyLoad('material/show'),
    meta: {
      title: 'Materials',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/materials/new',
    name: 'MaterialDetails',
    component: lazyLoad('material/show'),
    meta: {
      title: 'Materials',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/activity-time',
    name: 'activity_time',
    component: ActivityTime,
    meta: {
      title: 'Activity Time SLA',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/transshipment',
    name: 'transshipment',
    component: TransshipmentMaster,
    meta: {
      title: 'Transshipment Master',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/materialcategories',
    name: 'materialcategory',
    component: lazyLoad('material-category'),
    meta: {
      title: 'Material Categories',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/materialcategories/details/:id',
    name: 'materialcategorydetails',
    component: lazyLoad('material-category/show'),
    meta: {
      title: 'Material Category Details',
      requiresAuth: true,
    },
  },

  {
    path: '/mdm/redirection/details/:id',
    name: 'redirectiondetails',
    component: lazyLoad('redirection-master/show'),
    meta: {
      title: 'Redirection Details',
      requiresAuth: true,
    },
  },

  {
    path: '/mdm/redirection',
    name: 'redirection',
    component: lazyLoad('redirection-master'),
    meta: {
      title: 'Redirection Master',
      requiresAuth: true,
    },
  },

  {
    path: '/mdm/freight-zone',
    name: 'freight_zone',
    component: FreightZone,
    meta: {
      title: 'Freight Zone',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/legal-entity',
    name: 'legal_entity',
    component: LegalEntity,
    meta: {
      title: 'Legal Entity',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/budget',
    name: 'budget',
    component: lazyLoad('budget'),
    meta: {
      title: 'Budget',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/ndc',
    name: 'ndc_master',
    component: lazyLoad('ndc/NdcMasterList'),
    meta: {
      title: 'NDC Master',
      requiresAuth: true,
    },
  },
];

export default mdmV2;
